import NewInvoiceOrdersCount from './NewInvoiceOrdersCount';

export default NewInvoiceOrdersCount;
